import { getStore } from "../store/Store";
import { mutatorAction } from "satcheljs";

export const setShouldAnimateMutator: (shouldAnimate: boolean) => void = mutatorAction("setShouldAnimate", (shouldAnimate: boolean): void => {
    getStore().shouldAnimate = shouldAnimate;
});
